<template>
    <vs-row>
        <vs-col vs-lg="4" vs-xs="12" vs-sm="9" class="mb-3 mx-auto">
            <vx-card :title="$t('availabilities.subtitle')" class="px-3 pb-3">
                <div class="mt-6 sm:w-12/12">
                    <form
                        @submit.prevent="save"
                        @keydown="form.onKeydown($event)"
                    >
                        <div class="sm:w-12/12 mb-6">
                            <div class="vx-row justify-center">
                                <vs-input-number
                                    v-model="form.quantity"
                                    :min="0"
                                />
                                <has-error :form="form" field="quantity" />
                            </div>
                        </div>

                        <div class="flex flex-wrap justify-center">
                            <div class="my-4"></div>

                            <div class="flex flex-wrap justify-between">
                                <vs-button
                                    class="mb-4 md:mb-0"
                                    button="submit"
                                    >{{ $t("messages.edit.title") }}</vs-button
                                >
                            </div>
                        </div>
                    </form>
                </div>
            </vx-card>
        </vs-col>
        <vs-col vs-lg="7" vs-sm="9" vs-xs="12" class="mx-auto">
            <vx-card title="Cupos en tiempo real">
                <vs-row class="justify-center text-center">
                    <vs-col vs-lg="5" vs-sm="5" vs-xs="8" class="mb-4">
                        <vx-card>
                            <p class="text-left mb-5">Lugares disponibles</p>
                            <vs-row vs-justify="center" vs-align="center">
                                <vs-col class="circle">
                                    <h1>
                                        {{ qty }}
                                    </h1>
                                </vs-col>
                            </vs-row>
                        </vx-card>
                    </vs-col>
                    <vs-col vs-lg="1" vs-xs="12" vs-sm="1"></vs-col>
                    <vs-col vs-lg="5" vs-sm="5" vs-xs="8">
                        <vx-card>
                            <p class="text-left mb-5">Lugares ocupados</p>
                            <vs-row vs-justify="center" vs-align="center">
                                <vs-col class="circle">
                                    <h1>
                                        {{ form.places_not_availables }}
                                    </h1>
                                </vs-col>
                            </vs-row>
                        </vx-card>
                    </vs-col>
                </vs-row>
            </vx-card>
        </vs-col>
    </vs-row>
</template>
<script>
import Form from "vform";
import Swal from "sweetalert2";
import axios from "axios";

export default {
    name: "edit",
    data: () => ({
        form: new Form({
            quantity: 0,
            places_not_availables: 0,
        }),
        loading: true,
        qty: 0,
    }),
    beforeMount() {
        const vm = this;
        vm.getAvailabilities();
    },
    methods: {
        save() {
            this.edit();
        },
        async edit() {
            try {
                const { value } = await Swal.fire({
                    icon: "question",
                    title: this.$t("availabilities.confirmation"),
                    text: this.$t("availabilities.confirmation_description"),
                    showCancelButton: true,
                    cancelButtonColor: "#d33",
                    focusCancel: true,
                    confirmButtonText: this.$t("ok"),
                    cancelButtonText: this.$t("cancel"),
                });

                if (value) {
                    this.$vs.loading();
                    // eslint-disable-next-line no-unused-vars
                    const { data } = await this.form.patch(
                        `${process.env.VUE_APP_API_URL}/api/availabilities/1`
                    );

                    Swal.fire({
                        icon: "success",
                        title: this.$t("messages.edit.messages.success"),
                        text: this.$t(
                            "messages.edit.messages.success_description"
                        ),
                        confirmButtonText: this.$t("ok"),
                    });
                    await this.getAvailabilities();
                    this.$vs.loading.close();
                }
            } catch (error) {
                console.log("Ocurrió un error:", error);
                this.$vs.loading.close();
            }
        },
        async getAvailabilities() {
            const id = 1;

            try {
                this.$vs.loading();
                const { data } = await axios.get(
                    `${process.env.VUE_APP_API_URL}/api/availabilities/${id}`
                );
                console.log(data);
                this.form = Object.assign(this.form, data);
                this.qty = this.form.quantity - this.form.places_not_availables;
                this.$vs.loading.close();
            } catch (error) {
                Swal.fire({
                    icon: "warning",
                    title: this.$t("messages.errors.title"),
                    text: this.$t("messages.errors.description"),
                    confirmButtonText: this.$t("ok"),
                });
                console.log("Ocurrió un error:", error);

                this.$vs.loading.close();
            }
        },
    },
    metaInfo() {
        return { title: this.$t("availabilities.title") };
    },
};
</script>
<style lang="scss">
.circle {
    width: 7em !important;
    background-color: #fe9b00;
    border-radius: 100%;
    margin-top: 0.25em;
    text-align: center;
}
.circle h1 {
    font-weight: bold;
    font-size: 4em;
    color: #fff;
    padding: 15%;
}
</style>
